import React from 'react';
import './ConfirmModal.css';

const ConfirmModal = ({ 
  isVisible, 
  title, 
  onConfirm, 
  onCancel,
  confirmText = "回主頁\nReturn to Home Page",
  cancelText = "取消\nCancel" 
}) => {
  if (!isVisible) return null;

  return (
    <div className="modal-overlay">
      <div className="confirmation-modal">
        <div className="modal-content">
          <h2 className="modal-title">
            {title.split('\n').map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < title.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </h2>
          <hr/>
          <div className="modal-buttons">
            <button className="modal-btn confirm-btn" onClick={onConfirm}>
              {confirmText}
            </button>
            <button className="modal-btn cancel-btn" onClick={onCancel}>
              {cancelText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal; 